<form class="search-field" [formGroup]="searchForm" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="fill" class="field-round search-field__field" [subscriptSizing]="'dynamic'">
    <fstr-icon class="ms-3 me-2 text-primary" matPrefix anchor="line-icon-search"></fstr-icon>

    <input matInput [placeholder]="'bibliotheek-zoek-placeholder' | fromDictionary" formControlName="query" />

    <!--<span matSuffix class="text-dark me-3">TODO: select</span>-->
  </mat-form-field>
  <button class="button button--primary search-field__button" type="submit">
    <span>{{ 'bibliotheek-zoek-knop-tekst' | fromDictionary }}</span>
  </button>
</form>

<!--<pre>Zoekopracht: {{ query.value }}</pre>
<pre>initialQuery: {{ initialQuery() }}</pre>-->
